import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ActionButton',
  props: {
    btnClass: {
      type: String,
      required: true
    },
    envUrlKey: {
      type: String,
      required: true
    }
  },
  setup(__props) {

const props = __props;

  

  const targetUrl = ref('');

  onMounted(() => {
    // Set the URL after component is mounted to handle client-side hydration
    if (props.envUrlKey && process.env[props.envUrlKey]) {
      targetUrl.value = process.env[props.envUrlKey];
    } else {
      console.error(`Environment variable ${props.envUrlKey} not found`);
    }
  });
  
  const navigateToUrl = () => {
    // Directly check environment variable again as a fallback
    const url = targetUrl.value || (props.envUrlKey && process.env[props.envUrlKey]);
    
    if (url) {
      // Use more reliable window.open method that works with prerendered pages
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      console.error(`URL for ${props.envUrlKey} not available`);
    }
  };
  
return { __sfc: true,props, targetUrl, navigateToUrl }
}

})